import { ProjectStatus } from "constants/statuses";

export const DEFAULT_PROJECTS_PAGE_SIZE = 25;

export const defaultRequestParams = (statuses: ProjectStatus[]) => ({
  page_size: String(DEFAULT_PROJECTS_PAGE_SIZE),
  expand: "created_by_detail_snippet,home_detail,jobs,service_offering",
  status: statuses.join(","),
});
